import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { Botao } from "@/components/sistema";

/**
 * Rota que não existe.
 *
 * Sem barra de voltar: não há de onde voltar — quem cai aqui digitou ou
 * seguiu um link velho, e o histórico pode estar vazio. A saída é uma ação
 * explícita para o início, com o alvo de 56px do app.
 *
 * O texto estava em inglês dentro do código; agora passa pelo i18n como o
 * resto do app.
 */
const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background text-center">
      <div style={{ padding: "0 var(--gutter)", width: "100%", maxWidth: 420 }}>
        <p className="font-bold tabular-nums" style={{ fontSize: "var(--t-tela)" }}>
          404
        </p>
        <p
          className="leading-relaxed"
          style={{
            fontSize: "var(--t-corpo)",
            color: "var(--tinta-apoio)",
            padding: "12px 0 28px",
          }}
        >
          {t("errors.page_not_found")}
        </p>
        <Botao rotulo={t("viewer.go_home")} onClick={() => navigate("/")} />
      </div>
    </div>
  );
};

export default NotFound;
